import * as fire from "firebase"
import Config from "config"

export const addUser = (state, collection) => {
  // console.log(state);
  return (dispatch, getState, { getFirestore }) => {
    const fetchOptions = {
      method: "POST",
      body: JSON.stringify({
        email: state.email.trim(),
        name: state.name.trim(),
        status: state.status,
        verified: false,
        role: collection === "merchants" ? "merchant" : "customer",
      }),
      headers: {
        "Content-type": "application/json; charset=UTF-8",
      },
    }

    return fetch(Config.FirebaseFunctionUrl + "/app/addUser", fetchOptions)
      .then((res) => res.json())
      .then((data) => {
        console.log(data)
        const { adminError, customClaimError, firestoreError } = data
        if (
          adminError === null &&
          customClaimError === null &&
          firestoreError === null
        ) {
          return true
        }
        return false
      })
      .catch((err) => {
        console.log(err)
        return false
      })
  }
}

export const toggleUserStatus = (data) => {
  return (dispatch, getState, { getFirestore }) => {
    // Make async Call To Database
    const firestore = getFirestore()

    firestore
      .collection("merchants")
      .doc(data.uid)
      .update({ status: data.disabled })
      .then(() => {
        dispatch({ type: "USER_STATUS_SUCCESS" })
      })
      .catch((err) => {
        dispatch({ type: "USER_STATUS_FAILED" }, err)
      })
  }
}

export const verifyMerchant = (data) => {
  return (dispatch, getState, { getFirestore }) => {
    // Make async Call To Database
    const firestore = getFirestore()

    firestore
      .collection("merchants")
      .doc(data.uid)
      .update({ verified: true })
      .then(() => {
        dispatch({ type: "USER_STATUS_SUCCESS" })
      })
      .catch((err) => {
        dispatch({ type: "USER_STATUS_FAILED" }, err)
      })
  }
}

export const addAccountDetails = (routingNumber, accountNumber, uid) => {
  // console.log(routingNumber, accountNumber, uid);
  return (dispatch, getState, { getFirestore }) => {
    // Make async Call To Database
    const firestore = getFirestore()

    return firestore
      .collection("merchants")
      .doc(uid)
      .update({
        routingNumber,
        accountNumber,
      })
      .then(() => {
        console.log("Account Details Updated.")
        // dispatch({ type: 'USER_STATUS_SUCCESS' });
        return true
      })
      .catch((err) => {
        console.log(`Account Details Not Updated. Error:\n${err}`)
        // dispatch({ type: 'USER_STATUS_FAILED' }, err);
        return false
      })
  }
}

export const incrementTotalOrders = (uid) => {
  return (dispatch, getState, { getFirestore }) => {
    const firestore = getFirestore()

    return firestore
      .collection("merchants")
      .doc(uid)
      .update({
        totalOrders: fire.firestore.FieldValue.increment(1),
      })
      .then(() => {
        console.log("Total Orders Incremented.")
        return true
      })
      .catch((err) => {
        console.log(`Total Orders Not Incremented. Error:\n${err}`)
        return false
      })
  }
}

export const doesUserExist = (email = "") => {
  return (dispatch, getState, { getFirestore }) => {
    const fetchOptions = {
      method: "POST",
      body: JSON.stringify({
        email: email.trim(),
      }),
      headers: {
        "Content-type": "application/json; charset=UTF-8",
      },
    }

    return fetch(
      Config.FirebaseFunctionUrl + "/app/doesUserExist",
      fetchOptions
    )
      .then((res) => res.json())
      .then((data) => {
        console.log(data)
        const { userExists, uid, error } = data
        return { userExists, uid, error }
      })
      .catch((err) => {
        console.log(err)
        return { userExists: false }
      })
  }
}

export const resetPassword = (uid = "", password = "") => {
  return (dispatch, getState, { getFirestore }) => {
    const fetchOptions = {
      method: "POST",
      body: JSON.stringify({
        uid: uid.trim(),
        password: password.trim(),
      }),
      headers: {
        "Content-type": "application/json; charset=UTF-8",
      },
    }

    return fetch(
      Config.FirebaseFunctionUrl + "/app/resetPassword",
      fetchOptions
    )
      .then((res) => res.json())
      .then((data) => {
        console.log(data)
        const { passwordReset, error } = data
        return { passwordReset, error }
      })
      .catch((err) => {
        console.log(err)
        return { passwordReset: false }
      })
  }
}

export const setMergeMerchantOrderSlots = (data) => {
  return (dispatch, getState, { getFirestore }) => {
    // Make async Call To Database
    // console.log(JSON.stringify(data, null, 4));
    const firestore = getFirestore()

    firestore
      .collection("slots")
      .doc(data.docId)
      .set(
        {
          [data.updatedOrderSlotsId]: data.updatedOrderSlots,
        },
        { merge: true }
      )
      .then(() => {
        console.log("Merchant Order Slots Set Merged.")
        // dispatch({ type: 'USER_STATUS_SUCCESS' });
      })
      .catch((err) => {
        console.log(`Merchant Order Slots NOT Set Merged. Error:\n${err}`)
        // dispatch({ type: 'USER_STATUS_FAILED' }, err);
      })
  }
}

export const updateMerchantOrderSlots = (data) => {
  return (dispatch, getState, { getFirestore }) => {
    // Make async Call To Database
    // console.log(JSON.stringify(data, null, 4));
    const firestore = getFirestore()

    firestore
      .collection("slots")
      .doc(data.docId)
      .update(data.updateData)
      .then(() => {
        console.log("Merchant Order Slots Updated.")
        // dispatch({ type: 'USER_STATUS_SUCCESS' });
      })
      .catch((err) => {
        console.log(`Merchant Order Slots NOT Updated. Error:\n${err}`)
        // dispatch({ type: 'USER_STATUS_FAILED' }, err);
      })
  }
}

export const cancelOrConfirmOrder = (data) => {
  return (dispatch, getState, { getFirestore }) => {
    const firestore = getFirestore()

    const allData = {
      cancel: {
        updateObj: {
          merchantCancelled: true,
          merchantCancelledTimestamp: new Date(),
          // merchantConfirmed: false,
        },
        thenMsg: "Order Cancelled",
        catchMsg: "Order NOT Cancelled",
      },
      confirm: {
        updateObj: {
          // merchantCancelled: false,
          merchantConfirmed: true,
          merchantConfirmedTimestamp: new Date(),
        },
        thenMsg: "Order Confirmed",
        catchMsg: "Order NOT Confirmed",
      },
    }

    let statusData = allData[data.status]

    if (statusData) {
      return firestore
        .collection("orders")
        .doc(data.orderId)
        .update(statusData.updateObj)
        .then(() => {
          console.log(`${statusData.thenMsg}`)
          return true
          // dispatch({ type: 'USER_STATUS_SUCCESS' });
        })
        .catch((err) => {
          console.log(`${statusData.catchMsg} Error:\n${err}`)
          return false
          // dispatch({ type: 'USER_STATUS_FAILED' }, err);
        })
    }
    console.log(
      "cancelOrConfirmOrder. `statusData` Not Available. No Action Initiated."
    )
    return Promise.resolve(false)
    // return Promise.reject(new Error('cancelOrConfirmOrder. `statusData` Not Available'));
  }
}
